"use client";

import { c as _c } from "react/compiler-runtime";
import { Check } from "lucide-react";
import type { CampaignPageSection } from "@growwithai/shared";
import { sectionBgStyle, sectionHeadingStyle } from "../section-style";
type BenefitsProps = Extract<CampaignPageSection, {
  type: "benefits";
}>;

/** Grid keunggulan: ikon centang brand + judul + deskripsi singkat. */
export default function BenefitsSection(t0) {
  const $ = _c(18);
  const {
    section
  } = t0;
  if (section.items.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== section.custom_style) {
    t1 = sectionBgStyle(section.custom_style);
    $[0] = section.custom_style;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== section.custom_style) {
    t2 = sectionHeadingStyle(section.custom_style);
    $[2] = section.custom_style;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = section.heading ?? "Kenapa Belajar di Sini?";
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <h2 className="text-center text-2xl font-bold tracking-tight text-warm-black md:text-3xl" style={t2}>{t3}</h2>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = `mt-8 grid gap-5 sm:grid-cols-2 ${section.items.length >= 3 ? "lg:grid-cols-3" : ""}`;
  let t6;
  if ($[7] !== section.items) {
    t6 = section.items.map(_temp);
    $[7] = section.items;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <div className={t5}>{t6}</div>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t4 || $[13] !== t7) {
    t8 = <div className="mx-auto max-w-6xl px-5">{t4}{t7}</div>;
    $[12] = t4;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t1 || $[16] !== t8) {
    t9 = <section className="bg-white py-14 md:py-20" style={t1}>{t8}</section>;
    $[15] = t1;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}
function _temp(item, i) {
  return <div key={i} className="flex items-start gap-3.5 rounded-2xl border border-black/[0.06] bg-warm-cream/50 p-5"><span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[var(--brand-primary)]/10"><Check className="h-4 w-4 text-[var(--brand-primary)]" strokeWidth={3} /></span><div className="min-w-0"><p className="text-[15px] font-semibold text-warm-black">{item.title}</p><p className="mt-1 text-[13.5px] leading-relaxed text-gray-600">{item.description}</p></div></div>;
}